export enum BULK_COHORTS_MODE {
	add = 'add',
	remove = 'remove',
}
export type BulkCohortsMode = BULK_COHORTS_MODE;
